const NAV_KEY = 'deliniext-navigating';

function isInternalLink(link) {
  if (link.target === '_blank' || link.hasAttribute('download')) return false;

  const href = link.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return false;
  }

  try {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return false;

    const currentPath = `${window.location.pathname}${window.location.search}`;
    const targetPath = `${url.pathname}${url.search}`;
    if (targetPath === currentPath && url.hash) return false;

    return true;
  } catch {
    return false;
  }
}

function showLoader() {
  document.documentElement.classList.remove('is-ready');
}

function hideLoader() {
  document.documentElement.classList.add('is-ready');
  sessionStorage.removeItem(NAV_KEY);
  restoreHashTarget();
}

function restoreHashTarget() {
  const id = decodeURIComponent(window.location.hash.replace(/^#/, ''));
  if (!id) return;
  const target = document.getElementById(id);
  if (!target) return;
  requestAnimationFrame(() => {
    target.scrollIntoView({ block: 'start' });
  });
}

function bindNavigation() {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || !isInternalLink(link)) return;

    sessionStorage.setItem(NAV_KEY, '1');
    showLoader();
  });
}

async function waitForPageReady() {
  if (document.readyState === 'loading') {
    await new Promise((resolve) => {
      document.addEventListener('DOMContentLoaded', resolve, { once: true });
    });
  }

  if (document.fonts?.ready) {
    try {
      await document.fonts.ready;
    } catch {
      /* ignore font load errors */
    }
  }

  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });
}

export function initLoader() {
  bindNavigation();
  waitForPageReady().then(hideLoader);
}
